import type { VisualizationProps } from './types';

/**
 * BedroomSVG — спальня: кровать (decorative) + прикроватная тумбочка.
 * Зоны: facade, corpus, handles. Без countertop/hooks. Конвенции — `./types.ts`.
 */
export function BedroomSVG({ facadeColor, corpusColor, handlesColor }: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />
      {/* Кровать (decorative) */}
      <rect
        x="80"
        y="50"
        width="180"
        height="20"
        fill="#c8b8a8"
        stroke="#000000"
        strokeWidth="1"
        rx="3"
      />
      <rect
        x="80"
        y="70"
        width="180"
        height="80"
        fill="#e8d8c8"
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="100"
        y="75"
        width="50"
        height="20"
        fill="#fff"
        stroke="#000000"
        strokeWidth="0.5"
        rx="3"
      />
      <rect
        x="190"
        y="75"
        width="50"
        height="20"
        fill="#fff"
        stroke="#000000"
        strokeWidth="0.5"
        rx="3"
      />
      {/* Прикроватная тумбочка */}
      <rect
        data-testid="zone-corpus"
        x="270"
        y="120"
        width="40"
        height="65"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-facade"
        x="274"
        y="124"
        width="32"
        height="57"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-handles"
        x="285"
        y="148"
        width="8"
        height="2"
        fill={handlesColor}
        rx="1"
      />
      <text
        x="290"
        y="170"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="263"
        y="155"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
    </svg>
  );
}
